import styled from 'styled-components'
import React from 'react'
import {useAttendeeVariables} from 'Event'
import {Font, fontStyles} from 'lib/FontSelect'
import {
  BlogSectionProps,
  TownhallBlogPost,
} from 'Event/template/Townhall/Dashboard/Main/BlogSection'
import {CAPS} from 'lib/ui/typography/FontStyleInput'

export default function Title(props: {
  post: TownhallBlogPost
  postStyles?: BlogSectionProps['postStyles']
  textColor: string
}) {
  const {post, postStyles, textColor} = props
  const v = useAttendeeVariables()

  return (
    <TitleText
      textColor={textColor}
      titleTextColor={postStyles?.titleTextColor}
      fontSize={postStyles?.titleFontSize}
      font={postStyles?.titleFont}
    >
      {v(post.title)}
    </TitleText>
  )
}

const TitleText = styled.h2<{
  textColor: string
  titleTextColor?: string | null
  fontSize?: number
  font?: Font | null
}>`
  ${(props) =>
    fontStyles({
      family: props.font?.family || 'inherit',
      variants: props.font?.variants || [],
      styles: props.font?.styles || [CAPS],
    })};
  color: ${(props) =>
    props.titleTextColor ? props.titleTextColor : props.textColor} !important;
  margin: 0;
  font-size: ${(props) => props.fontSize}px;
`
